<template>
    <section  id="dormir"  class="SleepSection" v-if="hasContent">
      <div class="SleepSection__wrap">
        <header class="SleepSection__head">
          <h2 class="SleepSection__title pb-3" :class="isPhone ? 'merriweather-reg-18' : 'merriweather-reg-32'">Pour dormir</h2>
          <p v-if="text" class="SleepSection__lead raleway-reg-p15">{{ text }}</p>
        </header>
  
        <div class="SleepSection__railWrap">
          <button
            class="SleepSection__nav prev"
            :disabled="!canPrev"
            @click="scroll(-1)"
            aria-label="Précédent"
          >
            ‹
          </button>
  
          <div
            ref="rail"
            class="SleepSection__rail"
            @scroll="updateNav"
          >
            <figure
              v-for="(src, i) in images"
              :key="i"
              class="SleepSection__item"
            >
              <img :src="src" :alt="`Pour dormir – photo ${i+1}`" loading="lazy" />
            </figure>
          </div>
  
          <button
            class="SleepSection__nav next"
            :disabled="!canNext"
            @click="scroll(1)"
            aria-label="Suivant"
          >
            ›
          </button>
        </div>
      </div>
    </section>
  </template>
  
  <script>
  export default {
    name: 'SleepSection',
    props: {
      text: { type: String, default: '' },
      images: { type: Array, default: () => [] }
    },
  data () {
    return { canPrev: false, canNext: false, isPhone: window.innerWidth < 768 }
  },
    computed: {
      hasContent () {
        return (this.text && this.text.trim().length) || (this.images && this.images.length)
      }
    },
    methods: {
      railEl () { return this.$refs.rail },
      updateNav () {
        const el = this.railEl()
        if (!el) return
        const max = el.scrollWidth - el.clientWidth - 1
        this.canPrev = el.scrollLeft > 2
        this.canNext = el.scrollLeft < max
      },
      scroll (dir) {
        const el = this.railEl()
        if (!el) return
        const delta = Math.max(240, Math.floor(el.clientWidth * 0.9)) * dir
        el.scrollTo({ left: el.scrollLeft + delta, behavior: 'smooth' })
      },
      onResize () { this.$nextTick(this.updateNav) }
    },
    mounted () {
      this.updateNav()
      window.addEventListener('resize', this.onResize, { passive: true })
    },
    beforeDestroy () {
      window.removeEventListener('resize', this.onResize)
    }
  }
  </script>
  
  <style>
  .SleepSection { padding: 32px 16px; }
  .SleepSection__wrap { max-width: 1200px; margin: 0 auto; }
  .SleepSection__head { text-align: center; margin-bottom: 18px; }
  .SleepSection__title {
    margin: 0 0 8px;
  }
  .SleepSection__lead {
    line-height: 1.8;
    margin: 0 auto;
    max-width: 980px;
    color: #222;
  }
  
  .SleepSection__railWrap {
    position: relative;
  }
  .SleepSection__rail {
    display: grid;
    grid-auto-flow: column;
    grid-auto-columns: minmax(280px, 36%);
    gap: 12px;
    overflow-x: auto;
    padding: 6px 40px; 
    scroll-snap-type: x mandatory;
    scrollbar-width: none;
  }
  .SleepSection__rail::-webkit-scrollbar { display: none; }
  
  @media (max-width: 860px) {
    .SleepSection__rail { grid-auto-columns: 86%; padding: 6px 36px; }
  }
  
  .SleepSection__item {
    scroll-snap-align: start;
    margin: 0;
    border-radius: 12px;
    overflow: hidden;
    background: #f4f4f4;
    position: relative;
    aspect-ratio: 4/3;
  }
  .SleepSection__item img {
    width: 100%; height: 100%; object-fit: cover; display: block;
  }
  
  .SleepSection__nav {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 40px; height: 40px;
    border-radius: 999px;
    border: none;
    background: rgba(0,0,0,.45);
    color: #fff;
    font-size: 26px;
    line-height: 1;
    display: grid; place-items: center;
    cursor: pointer;
    transition: background .2s ease, opacity .2s ease;
    z-index: 2;
  }
  .SleepSection__nav:hover { background: rgba(0,0,0,.6); }
  .SleepSection__nav:disabled { opacity: .35; cursor: default; }
  .SleepSection__nav.prev { left: 4px; }
  .SleepSection__nav.next { right: 4px; }
  
  @media (pointer: coarse) {
    .SleepSection__nav { background: rgba(0,0,0,.35); }
  }
  </style>  